import React from "react";
import { HERO_IMAGE, CONTACT } from "@/lib/data";
import { MapPin, Star } from "lucide-react";

export const Hero = ({ onBookClick }) => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="DT Detail mobile auto detailing van at a customer's home"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-32 w-full">
        <div className="max-w-3xl reveal">
          <div className="flex items-center gap-2 mb-8">
            <div className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20">
              <MapPin className="w-3.5 h-3.5 text-white" />
              <span className="text-xs font-medium text-white tracking-wide uppercase">
                {CONTACT.area}
              </span>
            </div>
            <div className="flex items-center gap-1 px-3 py-1.5 rounded-full bg-white/10 backdrop-blur-md border border-white/20">
              <Star className="w-3.5 h-3.5 fill-white text-white" />
              <span className="text-xs font-medium text-white tracking-wide">
                Mobile Service
              </span>
            </div>
          </div>

          <p
            data-testid="hero-kicker"
            className="hidden"
          />

          <h1
            data-testid="hero-headline"
            className="font-heading font-bold text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight leading-[1.05] mb-10"
          >
            DT Detail
          </h1>

          <div className="flex flex-wrap items-center gap-3">
            <a
              href="#services"
              data-testid="hero-view-services-link"
              className="bg-white/10 backdrop-blur-md border border-white/30 text-white hover:bg-white/20 px-8 py-4 rounded-md font-semibold text-base transition-all"
            >
              View Services
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 hidden sm:flex flex-col items-center gap-2 text-white/70">
        <span className="text-xs uppercase tracking-[0.3em]">Scroll</span>
        <div className="w-px h-12 bg-white/40" />
      </div>
    </section>
  );
};
